<template>
  <div class="closed">
    <img class="errorPic" src="./../../assets/img/closed-null.png" alt="" />
    <span class="sorry">
      <van-icon
        name="warning"
        color="rgba(226, 49, 48, 1)"
        size="20"
        style="margin-right: 0.1rem"
      />Sorry
    </span>
    <span class="sorrryAbout" v-if="$store.state.closed==-1"> 该商城已过期 </span>
    <span class="sorrryAbout" v-else> {{ this.$store.state.webCount.net_off_content }} </span>
  </div>
</template>

<script>
export default {
  name: 'error',
  data() {
    return {
      datas: ''
    }
  },
  created() {},
  methods: {
    goback: function () {
      history.go(-1)
    },
    gohome: function () {
      this.$router.push({ path: '/' })
    },
    getwebinfo: function () {
      var closed = localStorage.getItem('closed')
      if (closed == 1) {
        this.$router.push({ path: '/' })
      }
    }
  },
  mounted() {
    this.getwebinfo()
  }
}
</script>

<style lang="less" scoped>
.closed {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;

  img {
    width: 5.04rem;
    height: 3.76rem;
  }

  .sorry {
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: 0.48rem;
    margin-top: 0.2rem;
  }

  .sorrryAbout {
    font-size: 0.24rem;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: rgba(38, 38, 38, 0.5);
    line-height: 0.42rem;
    margin-top: 0.1rem;
    padding: 0 0.2rem;
  }

  .visit-the {
    width: 4rem;
    height: 0.96rem;
    background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
    border-radius: 0.48rem;
    font-size: 0.3rem;
    font-weight: 500;
    color: #ffffff;
    line-height: 0.96rem;
    text-align: center;
    margin-top: 0.2rem;
  }

  .text-cent {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.86rem;
    margin-top: 0.8rem;
    display: flex;
    justify-content: space-between;
    .text-btn {
      width: 2.68rem;
      height: 0.8rem;
      background: #fdf5f5;
      border-radius: 0.5rem;
      border: 0.02rem solid #e23331;
      font-size: 0.3rem;
      font-weight: 500;
      color: #e23331;
      line-height: 0.42rem;
    }

    .text-home {
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/closed.vue